export const QUERY_PARAM_LANGUAGE = 'lang';
export const QUERY_PARAM_STORE_IDENTIFIER = '_m';
export const QUERY_PARAM_DEBUG = '_d';
export const QUERY_PARAM_CART_ID = 'cart_id';
export const QUERY_PARAM_SESSION_ID = 'session_id';
export const QUERY_PARAM_RESELLER_LOCATION_ID = 'reseller_location_id';
export const QUERY_PARAM_RESELLER_ID = 'reseller_id';
export const QUERY_PARAM_MERCHANT_ID = 'merchant_id';
export const QUERY_PARAM_PARENT_MERCHANT_ID = 'emerchant_id';
export const QUERY_PARAM_TRADES_FLAG = 'trades_flag';
export const QUERY_PARAM_TRADES_ORIGIN = 'trades_origin';
export const QUERY_PARAM_TRADES_UUID = 'trades_uuid';
export const QUERY_PARAM_PREVIOUS_PAGE_VALUE = 'prevPage';
export const QUERY_PARAM_PREVIOUS_PAGE_TYPE = 'prevPageType';
export const QUERY_PARAM_AUTH_REDIRECT = '_auth_redir';
